import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { useLanguage } from "../../i18n/LanguageContext";

// Lists the parts of an opened link that couldn't be read and were
// replaced by a default (see linkNormalizer). The warnings arrive once, as
// navigation state of the redirect, so they are copied into local state:
// the next in-app navigation clears location.state, but the notice should
// stay until it is dismissed.
export default function LinkNotice() {
  const location = useLocation();
  const [warnings, setWarnings] = useState([]);
  const { t } = useLanguage();
  const incoming = location.state?.linkWarnings;

  useEffect(() => {
    if (incoming?.length) {
      setWarnings(incoming);
    }
  }, [incoming]);

  if (!warnings.length) {
    return null;
  }

  return (
    <div className="link-notice note" role="status">
      <div className="link-notice-text">
        <strong>{t("linkNotice.title")}</strong>
        <ul>
          {warnings.map((warning) => (
            <li key={warning}>{warning}</li>
          ))}
        </ul>
      </div>
      <IconButton
        size="small"
        aria-label={t("common.dismiss")}
        onClick={() => setWarnings([])}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </div>
  );
}
